// src/pages/LoginPage.js

import { useEffect, useState } from 'react';
import config from '../config';
import LoginBox from '../components/Login/LoginBox';
import RegisterBox from '../components/Login/RegisterBox';
import ForgotPasswordBox from '../components/Login/ForgotPasswordBox';
import ResetPasswordBox from '../components/Login/ResetPasswordBox';
import Footer from '../components/Footer';
import '../components/Login/Login.css';

export default function Login() {

  // State to control which form to show: 'login' 'register' 'forgot' or 'reset'
  const [formType, setFormType] = useState('login');

  // Track registration success
  const [registrationSuccessMessage, setRegistrationSuccessMessage] = useState('');

  useEffect(() => {
    // Update the document title when the form type changes
    const titles = {
      login: `Login | ${config.siteTitle}`,
      register: `Join | ${config.siteTitle}`,
      forgot: `Reset Password | ${config.siteTitle}`,
      reset: `New Password | ${config.siteTitle}`,
    };
    document.title = titles[formType] || `${config.siteTitle}`;
  }, [formType]);

  // Switch to Reset form if there's a token, or Register form if t=register
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const formTypeParam = params.get('t');

    if (token) {
      setFormType('reset');
    } else if (formTypeParam === 'register') {
      setFormType('register');
    }
  }, []);

  // Handler functions to switch between forms
  const handleSwitchToRegister = () => {
    setFormType('register');
    setRegistrationSuccessMessage('');
  };

  const handleSwitchToLogin = () => setFormType('login');
  const handleSwitchtoForgot = () => setFormType('forgot');

  // What RegisterBox calls when registration succeeds
  const handleRegistrationSuccess = () => {
    setRegistrationSuccessMessage('Account created. Check your email to verify.');
    setFormType('login');
  };

  return (
    <div className="login-page-container">
      <main className="form-panel">
        {/* Brand Header */}
        <div className="mobile-branding">
          <h1 className="mobile-brand-title">{config.siteTitle}</h1>
          <p className="mobile-brand-subtitle">{config.siteTagline}</p>
        </div>

        <div className="login-card">

          {formType === 'login' && (
            <LoginBox
              registrationSuccessMessage={registrationSuccessMessage}
              onForgotPassword={handleSwitchtoForgot}
            />
          )}

          {formType === 'login' && (
            <div className="signup-link" style={{ marginTop: '1.5rem' }}>
              <p>
                New here?{' '}
                <button onClick={handleSwitchToRegister} className="link-button">
                  Create Account
                </button>
              </p>
            </div>
          )}

          {formType === 'forgot' && (
            <>
              <h2>Reset Password</h2>
              <ForgotPasswordBox onBack={handleSwitchToLogin} />
            </>
          )}

          {formType === 'reset' && (
            <>
              <h2>New Password</h2>
              <ResetPasswordBox onBack={handleSwitchToLogin} />
            </>
          )}

          {formType === 'register' && (
            <>
              <h2>Join the Crew</h2>
              <RegisterBox onRegistrationSuccess={handleRegistrationSuccess} />
              <div className="signup-link" style={{ marginTop: '1.5rem' }}>
                <p>
                  Already a member?{' '}
                  <button onClick={handleSwitchToLogin} className="link-button">
                    Sign In
                  </button>
                </p>
              </div>
            </>
          )}
        </div>

        <Footer />
      </main>
    </div>
  );
}
